import React from 'react';
import './CatalogButton.css';

const CATALOG_PDF_PATH = '/NishGlobalTR2025.pdf';

const CatalogButton: React.FC = () => {
  return (
    <a
      href={CATALOG_PDF_PATH}
      target="_blank"
      rel="noopener noreferrer"
      className="catalog-button"
      aria-label="Kataloğu aç"
    >
      <span className="catalog-progress-ring" aria-hidden="true" />
      <span className="catalog-button-inner">
      <svg
        width="26"
        height="26"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M6 2h8l4 4v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path
          d="M14 2v4h4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path
          d="M12 10v7"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M9.5 14.5 12 17l2.5-2.5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      </span>
      <span className="catalog-tooltip">Katalog (PDF)</span>
    </a>
  );
};

export default CatalogButton;

